import { render, staticRenderFns } from "./VTableButton.vue?vue&type=template&id=b2998d24&scoped=true"
import script from "./VTableButton.vue?vue&type=script&lang=js"
export * from "./VTableButton.vue?vue&type=script&lang=js"
import style0 from "./VTableButton.vue?vue&type=style&index=0&id=b2998d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2998d24",
  null
  
)

export default component.exports